<template>
    <div :id="'indicator_'+ indicator.id" class="card mt-3">
        <div class="card-body">
            <div class="row">
                <div class="col-1 indicator-title pr-0">
                    {{ indicator.section_number }}.{{ indicator.indicator_number }}
                </div>
                <div class="col-8 indicator-title pl-3">
                    {{ indicator.short_text }}
                    <small><i>
                        <a  data-toggle="collapse" 
                            :id="'toggle_details_indicator_'+ indicator.id" 
                            :href="'#details_indicator_'+ indicator.id" 
                            aria-expanded="false" 
                            :aria-controls="'indicator_details_'+ indicator.id"
                        >
                            toggle details
                        </a>
                    </i></small>
                </div>
                <div v-if="initialIndicators" class="col-3 grade-badge">
                    <span class="badge badge-dark">{{ initialIndicator.grade == '0' ? scoringLabels[0] : '' }}</span>
                    <span class="badge badge-danger">{{ initialIndicator.grade == '1' ? scoringLabels[1] + ' (1)' : '' }}</span>
                    <span class="badge badge-bronze">{{ initialIndicator.grade == '2' ? scoringLabels[2] + ' (2)' : '' }}</span>
                    <span class="badge badge-silver">{{ initialIndicator.grade == '3' ? scoringLabels[3] + ' (3)' : '' }}</span>
                    <span class="badge badge-gold">{{ initialIndicator.grade == '4' ? scoringLabels[4] + ' (4)' : '' }}</span>
                </div>
            </div><!-- .row -->
            <div class="row">
                <div class="col">
                    <div class="collapse collapse-all details mt-2 pl-4" :id="'details_indicator_'+ indicator.id">
                        <div class="full-text mt-1">
                            <span v-html="indicator.full_text"></span>
                        </div>
                        <div class="law-rule mt-1">
                            <b><span v-html="indicator.law"></span></b>
                        </div>
                        <div class="best-practice mt-1">
                            <span v-html="indicator.best_practice"></span>
                        </div>
                        <div class="notes mt-1">
                            <span v-html="indicator.notes"></span>
                        </div>
                    </div>
                </div>
            </div><!-- .row -->
            <div class="row">
                <div class="col mt-3">
                    <div>Initial Comments:</div>
                    <textarea v-if="initialIndicators" :value="initialIndicator.comment" class="form-control" disabled></textarea>
                </div>
            </div><!-- .row -->
            <div v-if="[1,2,3].includes(initialIndicator.grade)">
                <div class="row">
                    <div class="col mt-3">
                        <div>Strategy:</div>
                        <textarea 
                            v-if="planIndicators" 
                            :value="planIndicator.strategy" 
                            class="form-control" 
                            :id="'strategy_indicator_'+ indicator.id"
                            :disabled="cycle.completed_at" 
                            placeholder="Describe strategy here"
                            @blur="updateIndicator($event, 'strategy')"
                        ></textarea>
                    </div>
                </div><!-- .row -->
                <div class="form-group row mt-3">
                    <label for="inputEmail3" class="col-3 col-form-label">Person Responsible</label>
                    <div class="col-9">
                        <input 
                            v-if="planIndicators"  
                            type="text" 
                            class="form-control" 
                            :id="'responsible_indicator_'+ indicator.id"
                            :disabled="cycle.completed_at" 
                            :value="planIndicator.person_responsible" 
                            @blur="updateIndicator($event, 'person_responsible')"
                        >
                    </div>
                </div><!-- .row -->
                <div class="form-group row mt-3">
                    <label class="col-2 col-form-label">Target date</label>
                    <div class="col-4">
                        <input 
                            v-if="planIndicators" 
                            type="date" 
                            class="form-control"
                            :id="'target_indicator_'+ indicator.id"
                            :disabled="cycle.completed_at" 
                            :value="formatDate(planIndicator.targeted_at)" 
                            @blur="updateIndicator($event, 'targeted_at')"
                        >
                    </div>
                    <label class="col-2 col-form-label px-0">Completion date</label>
                    <div class="col-4">
                        <input 
                            v-if="planIndicators" 
                            type="date" 
                            class="form-control" 
                            :id="'completion_indicator_'+ indicator.id"
                            :disabled="cycle.completed_at" 
                            :value="formatDate(planIndicator.completed_at)" 
                            @blur="updateIndicator($event, 'completed_at')"
                        >
                    </div>
                </div><!-- .row -->
            </div>
        </div><!-- .card-body -->
    </div>
</template>

<style scoped>
.indicator-title {
    font-size: 1em;
    font-weight: 700;
    line-height: 1.4;
}
.grade-badge .badge {
    font-size: 1.1em;
    color: #fff;
}
.badge-gold {
    background-color: #D6AF36;
}
.badge-silver {
    background-color: #A7A7AD;
}
.badge-bronze {
    background-color: #A77044;
}
.details {
    font-size: 15px;
    line-height: 1.3;
}
textarea::placeholder {
    color: lightgray;
    font-style: italic;
}
</style>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'

    export default {
        props: {
            indicator: Object,
            scoringLabels: Object
        },

        components: { moment },

        methods: {
            updateIndicator (e, updated) {
                let data = {
                    assessment_cycle_id: this.cycle.id,
                    section_number: this.indicator.section_number,
                    indicator_number: this.indicator.indicator_number
                }
                if (updated == 'strategy') {
                    data.strategy = e.target.value
                }
                if (updated == 'person_responsible') {
                    data.person_responsible = e.target.value
                }
                if (updated == 'targeted_at') {
                    data.targeted_at = e.target.value
                }
                if (updated == 'completed_at') {
                    data.completed_at = e.target.value
                }
                this.$store.dispatch('plan/savePlanIndicator', data)
            },
            formatDate (date) {
                return date ? moment(date).format('YYYY-MM-DD') : null
            }
        },

        computed: {
            ...mapState({
                planIndicators: state => state.plan.planIndicators,
                initialIndicators: state => state.initial.initialIndicators,
                cycle: state => state.cycle.cycle
            }),
            planIndicator () {
                return this.planIndicators[this.indicator.section_number][this.indicator.indicator_number] || {}
            },
            initialIndicator () {
                return this.initialIndicators[this.indicator.section_number][this.indicator.indicator_number]
            }
        }
    }
</script>
